export default __webpack_public_path__ + "static/media/gallery_04.a4426a5b.jpg";